/**
 * The approval status vocabulary, in a module that imports nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so what a search module reaches for
 * lands in the initial chunk. `approvals.route.search.ts` builds its
 * filter-only `APPROVAL_STATUS_FILTERS` by spreading this tuple, and taking it
 * from `schemas/approval.schema.ts` dragged every approval request, counts and
 * decision-input schema along with it.
 *
 * The tuple is the single source of truth: `approval.schema.ts` builds
 * `approvalStatusSchema` from it, so the URL parser and the wire parser cannot
 * drift.
 */

export const APPROVAL_STATUSES = ["pending", "approved", "rejected", "cancelled"] as const;
export type ApprovalStatusName = (typeof APPROVAL_STATUSES)[number];
